import { useEffect, useRef } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useApp, API } from "../context";

const PENDING_KEY = "iw_pending_friend_code";

// Invisible helper: the moment a user is signed in AND a friend code was saved
// from a scanned QR / invite link, finish the connection automatically. This is
// what makes "scan -> sign up -> instantly friends" work no matter where the
// signup flow drops them.
export default function PendingFriendConnect() {
  const { user } = useApp();
  const done = useRef(false);

  useEffect(() => {
    if (done.current || !user) return;
    let code = "";
    try { code = localStorage.getItem(PENDING_KEY) || ""; } catch { /* noop */ }
    if (!code) return;
    done.current = true;
    try { localStorage.removeItem(PENDING_KEY); } catch { /* noop */ }
    const uid = user.id || user.email;
    axios.post(`${API}/friends/connect-by-code`, { user_id: uid, code })
      .then((r) => {
        const name = r.data?.friend?.display_name || "your friend";
        if (r.data?.already) return;
        if (r.data?.instant) toast.success(`🎉 You and ${name} are now friends!`);
        else toast.success(`Friend request sent to ${name}!`);
      })
      .catch(() => {});
  }, [user]);

  return null;
}
